module.exports = __webpack_public_path__ + "img/welcome-9ac1f4469951880b429c5a3f121e05d3.svg";